import React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';
import { useTheme, styled } from '@mui/material/styles';
import { FormWrapper } from './StyledComponents';
import { usePostWhiteLabelBrandingMutation } from 'services/webclock';
import { useWhiteLabeling } from '../../hooks/useWhiteLabeling';
import { useWhiteLabelContext } from 'providers/WhiteLabelProvider';

export default function WhiteLabelWrapper({ children, login = false }) {
  const theme = useTheme();
  const [postWhiteLabelBranding] = usePostWhiteLabelBrandingMutation();
  const { state: whiteLabelState, actions } = useWhiteLabelContext();
  const searchParams = new URLSearchParams(window.location.search);
  const whiteLabelClient = searchParams.get('wl');
  const isEnclosedMode = JSON.parse(searchParams.get('enclosed'));

  // White labeling setup
  useWhiteLabeling(
    postWhiteLabelBranding,
    whiteLabelClient,
    theme,
    actions.setWhiteLabelState,
    isEnclosedMode
  );

  return (
    <>
      {whiteLabelState.isLoading ? (
        <LinearProgress />
      ) : (
        <>
          {login ? (
            <StyledDiv>
              <FormWrapper
                customBackground={whiteLabelState?.backgroundColor}
                isEnclosedMode={whiteLabelState?.isEnclosedMode}
              >
                {children}
              </FormWrapper>
            </StyledDiv>
          ) : (
            <>{children}</>
          )}
        </>
      )}
    </>
  );
}

WhiteLabelWrapper.propTypes = {
  children: PropTypes.node,
  login: PropTypes.bool,
  enclosed: PropTypes.bool,
};

/** styled components */

const StyledDiv = styled('div')(() => ({
  height: '100%',
  width: '100%',
  position: 'absolute',
}));
